export default __webpack_public_path__ + "static/media/blackClock.03a7cf44.svg";